import { MetricSign, MetricType } from '../../recovery/component/recovery-metrics-panel/entity/DefaultMetric';
import { MetricBulkUploadParent } from './MetricBulkUploadDTO';
import { MetricGroup, MetricGroupRole } from './MetricGroup';

export class MetricProps {
  metricType = MetricType;
  metricSign = MetricSign;
  metricState = MetricState;
  metricParent = MetricBulkUploadParent;
  groupRole = MetricGroupRole;
}

export enum MetricState {
  noActionSelected,
  modalDeletePeriod,
  deletePeriods,
  modalShowChart,
  editAll,
  updatePeriod,
  modalSharedLink,
  modalCustomGroup,
  modalBulkUpload,
  periodEmptyState,
  groupEmptyState,
  managePeriods,
  reorder,
}

export class CustomGroup {
  group = new MetricGroup();
  showModal = false;
}
